var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CountingListFilters from '@backoffice/components/counting/CountingListFilters.vue';
import CreateCountingModal from '@backoffice/components/counting/CreateCountingModal.vue';
import { uuidFromIri } from '@shared/utils/iri';
import { UserRole } from '@shared/types/api/user';
const claims = namespace('claims');
let ChiffrageIndex = class ChiffrageIndex extends Vue {
    constructor() {
        super(...arguments);
        this.isModalOpen = false;
    }
    get isSupervisor() {
        var _a, _b;
        if ((_a = this.$auth.user) === null || _a === void 0 ? void 0 : _a.profile)
            return ((_b = this.$auth.user) === null || _b === void 0 ? void 0 : _b.profile) === 'superviseur';
        return this.$hasAccessLevel(UserRole.MANAGER_READONLY);
    }
    get filtersActivated() {
        const filters = this.filters;
        return Object.values(filters).some((val) => typeof val !== 'undefined');
    }
    get dynamicTotalPages() {
        return this.filtersActivated
            ? Math.ceil(this.totalFilteredClaims / this.itemsPerPage)
            : this.totalPages;
    }
    get paginationNote() {
        if (this.filtersActivated) {
            return `Dossiers: ${this.totalFilteredClaims} /  ${this.total}`;
        }
        else {
            return `Dossiers: ${this.total}`;
        }
    }
    async loadClaimsOnPageChange(page) {
        await this.changePage(page);
        await this.loadClaims();
    }
    onPageChange(page) {
        this.changePage(page);
    }
    onSort(by, direction) {
        this.sort({ by, direction });
    }
    onClick(row) {
        var _a;
        const identifier = (_a = this.$config.insurerConfig.backoffice) === null || _a === void 0 ? void 0 : _a.claimUrlIdentifier;
        const id = identifier ? row[identifier] : uuidFromIri(row.id);
        this.$goToLocalePath({ name: 'chiffrage-id-chiffrage', params: { id } });
    }
    formatDate(value) {
        const lang = this.$i18n.locale;
        const date = new Date(value);
        const dateFormat = new Intl.DateTimeFormat(lang, { dateStyle: 'short' });
        return dateFormat.format(date);
    }
    formatAmount(value) {
        const lang = this.$i18n.locale;
        const amount = value / 100;
        const numberFormat = new Intl.NumberFormat(lang, {
            style: 'currency',
            currency: 'EUR',
        });
        return numberFormat.format(amount);
    }
};
__decorate([
    claims.State('data')
], ChiffrageIndex.prototype, "data", void 0);
__decorate([
    claims.State('loading')
], ChiffrageIndex.prototype, "loading", void 0);
__decorate([
    claims.State('total')
], ChiffrageIndex.prototype, "total", void 0);
__decorate([
    claims.State('page')
], ChiffrageIndex.prototype, "page", void 0);
__decorate([
    claims.State('filters')
], ChiffrageIndex.prototype, "filters", void 0);
__decorate([
    claims.State('sorting')
], ChiffrageIndex.prototype, "sorting", void 0);
__decorate([
    claims.State('itemsPerPage')
], ChiffrageIndex.prototype, "itemsPerPage", void 0);
__decorate([
    claims.Getter('totalPages')
], ChiffrageIndex.prototype, "totalPages", void 0);
__decorate([
    claims.Getter('totalFilteredClaims')
], ChiffrageIndex.prototype, "totalFilteredClaims", void 0);
__decorate([
    claims.Action('loadClaims')
], ChiffrageIndex.prototype, "loadClaims", void 0);
__decorate([
    claims.Action('changePage')
], ChiffrageIndex.prototype, "changePage", void 0);
__decorate([
    claims.Action('sort')
], ChiffrageIndex.prototype, "sort", void 0);
__decorate([
    claims.Action('changeItemsPerPage')
], ChiffrageIndex.prototype, "changeItemsPerPage", void 0);
ChiffrageIndex = __decorate([
    Component({
        middleware: 'hasAccess',
        components: { CountingListFilters, CreateCountingModal },
        async fetch() {
            await this.loadClaims();
        },
        async activated() {
            await this.loadClaims();
        },
        nuxtI18n: {
            paths: {
                en: '/counting',
            },
        },
    })
], ChiffrageIndex);
export default ChiffrageIndex;
